// サイドメニュー・商品ページ アコーディオン
const btns = document.querySelectorAll('.js-toggle-btn');
const els = document.querySelectorAll('.js-toggle-content');

btns.forEach((btn, index) => {
    const el = els[index];

btn.addEventListener('click', function() {
  btn.classList.toggle('is-open');
  el.classList.toggle('is-open');
  if(el.classList.contains("is-open")){
      el.style.height = el.scrollHeight + 'px';
   }else{
      el.style.height = "0";
   }
    });
});